"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeService = exports.ResponseFix = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
require("rxjs/add/operator/toPromise");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL BITS
const notification_service_1 = require("./notification.service");
const user_service_1 = require("./user.service");
const roles_service_1 = require("./roles.service");
//LOCAL CLASS
class ResponseFix {
}
exports.ResponseFix = ResponseFix;
let ExchangeService = class ExchangeService {
    constructor(_http, _talk, _user, _roles) {
        this._http = _http;
        this._talk = _talk;
        this._user = _user;
        this._roles = _roles;
        //declarations
        this.biddersURL = '/exchangebidders';
    }
    pullBidders() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._http.get(this.biddersURL)
                .toPromise()
                .then(response => { return JSON.parse(response._body); })
                .catch(this._talk.handle);
        });
    }
};
exports.ExchangeService = ExchangeService;
exports.ExchangeService = ExchangeService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService,
        user_service_1.UserService,
        roles_service_1.RolesService])
], ExchangeService);
//# sourceMappingURL=exchange.service.js.map